const NAME = 'DOCUMENTS-INDEX';

// Handling of requests to /documents endpoint
export const REQUEST_DOCUMENTS = `${NAME}/REQUEST_DOCUMENTS`;
export const REQUEST_DOCUMENTS_SUCCESS = `${NAME}/REQUEST_DOCUMENTS_SUCCESS`;
export const REQUEST_DOCUMENTS_FAIL = `${NAME}/REQUEST_DOCUMENTS_FAIL`;

export const RESET_VIEW_STATE = `${NAME}/RESET_VIEW_STATE`;
export const RESET_STATE = `${NAME}/RESET_STATE`;
